<template>
  <div v-if="surveys && surveys.length">
    <survey-modal
      v-if="selectedSurvey"
      :survey="selectedSurvey"
      @cancel="cancelModal"
      @complete="completedSurvey"
    />
    <div>
      <div class="surveys-list">
        <div class="surveys-list__header">
          <h5 v-text="`You have ${surveys.length} Survey${surveys.length > 1 ? 's' : ''} to complete`"></h5>
        </div>
        <div class="surveys-list__body">
          <div
            v-for="(survey, key) in surveys"
            :key="key"
            class="surveys-list__body__survey"
            @click="selectSurvey(survey.s_id)"
          >
            <p v-text="survey.title"></p>
            <button @click="selectSurvey(survey.s_id)" class="btn">View</button>
          </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import SurveyModal from '../components/Modal'

  export default {
    name: 'survey-list',
    components: {
      SurveyModal
    },
    props: {
      userId: {
        type: String,
        required: true
      },
      clientId: {
        type: String,
        required: true
      }
    },
    data: () => ({
      showNotifications: false,
      selectedSurvey: null,
      surveys: [],
      logoUrl: null
    }),
    watch: {
      surveys: function (s) {
        if (s.length) this.showNotifications = true
      }
    },
    methods: {
      async getUserSurveys () {
        if (!this.userId || !this.clientId) return

        try {
          const { data } = await axios.get(`https://eymbhklhck.execute-api.eu-west-2.amazonaws.com/production/surveys`, {
            params: {
              userSurveys: true,
              userId: this.userId,
              clientId: this.clientId
            }
          })
          this.surveys = data.data
        } catch (error) {
          throw error
        }
      },
      async getClientsLogo () {
        if (!this.clientId) return
        try {
          const { data } = await axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/get-logo`, { params: { clientId: this.clientId }})
          this.logoUrl = data.url
        } catch (error) {
          throw error
        }
      },
      selectSurvey (id) {
        this.showNotifications = false
        this.selectedSurvey = this.surveys.filter(s => s.s_id === id)[0]
      },
      async completedSurvey () {
        await this.getUserSurveys()
        this.selectedSurvey = null
      },
      async cancelModal () {
        await this.getUserSurveys()
        this.selectedSurvey = null
        this.showNotifications = true
      }
    },
    async mounted () {
      await Promise.all([
        this.getUserSurveys(),
        this.getClientsLogo()
      ])
    }
  }
</script>

<style lang="scss" scoped>

  @import '../scss/date-picker';
  @import '../scss/variables';
  @import '../scss/bp';

  ::v-deep .survey {
    position: fixed;
    top: 140px;
    height: auto;
    max-height: calc(100% - 250px);
  }

  ::v-deep .survey__survey__content {
    max-height: 40vh;
  }

  .surveys-list {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid rgba($black, .1);

      i {
        margin-left: 20px;
        cursor: pointer;
      }
    }

    &__body {
      &__survey {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        transition: all .2s;
        cursor: pointer;

        &:hover {
          background: rgba($black, .1);
        }

        p {
          margin: 0;
          padding: 0;
        }

        .btn {
          padding: 5px 10px;
          background: none;
          border: none;
          color: $black;
          cursor: pointer;
          text-transform: uppercase;

          &:hover {
            background: rgba($black, 0.1);
          }
        }
      }
    }
  }

</style>